import React, {useState,useEffect} from 'react'
import { AppBar, Avatar, Button, Typography, Toolbar } from '@material-ui/core'
import { Link, useHistory, useLocation } from 'react-router-dom';
import SHIN from '../../images/grimmjow.png';
import ggl from '../../images/textl.png';
import bts from '../../images/bts.png';
import useStyles from './styles';
import decode from 'jwt-decode';
import { useDispatch } from 'react-redux';


const Navbar = () => {
  const classes = useStyles()
  
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('profile')));

  const history = useHistory()

  const location = useLocation()

  const dispatch = useDispatch()

  //console.log(user);

  const logout = () => {
    dispatch({type: 'LOGOUT' });
 
    history.push('/');

    setUser(null);
  }

  useEffect(() => {
    const token = user?.token;

    if (token) {
      const decodedToken = decode(token);

      if(decodedToken.exp * 1000 < new Date().getTime()) {
        logout();
      }
    }

    setUser(JSON.parse(localStorage.getItem('profile')));
  }, [location]);

  return (
    <AppBar className={classes.appBar} position="static" color="inherit">
    <Link to="/" className={classes.brandContainer}>
        <img src={ggl} alt="icon" height="65px"/>
        <img className={classes.image} src={SHIN} alt="icon" height="55px"/>
    </Link>
    
    <Toolbar className={classes.toolbar}>
        {user ? (
            <div className={classes.profile}>
                <Avatar className={classes.purple} alt={user.result.name} src={user.result.imageUrl}>{user.result.name.charAt(0)}</Avatar>
                <Typography className={classes.userName} variant="h6">{user.result.name}</Typography>
                <Button variant="contained" className={classes.logout} color="secondary" onClick={logout}>Logout</Button>
            </div>
        ) : (
            <Button component={Link} to="/auth" variant="contained" color="primary">Sign in</Button>
        )}
    </Toolbar>
        
      </AppBar>
  )
}

export default Navbar